'use client';

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const labelVariants = cva(
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
);

const Label = React.forwardRef(({ className, status, children, ...props }, ref) => {
  const statusDot = status ? (
    <span
      className={cn('inline-block h-2 w-2 rounded-full mr-2',
        {
          'bg-sky-500': status === 'primary',
          'bg-purple-500': status === 'secondary',
          'bg-green-500': status === 'success',
          'bg-orange-500': status === 'warning',
          'bg-red-500': status === 'error',
          'bg-black': status === 'neutral',
        }
      )}
    />
  ) : null;

  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants(), 'flex items-center', className)}
      {...props}
    >
      {statusDot}
      {children}
    </LabelPrimitive.Root>
  );
});
Label.displayName = 'Label';

export { Label };
